// inisTipiSayim.js — STATISTICS'teki INIS TIPI kutulari (22 Eyl 2026).
//
// 🔑 Serkan: *"RH seat inis girilince, PF night yazdigi gibi RH LND veya
//    CAT 1 EVS, CAT 2 EVS gibi istatistik tutacagiz, istatistik sayfasinda
//    gorunecek."* · *"Hayir, sadece PF'e yazilir."*
//
// - Tipler iPad'in END FLT "TYPE OF LNDG" menusunun AYNI metinleri
//   (iOS `EndFltLogic.inisTipleri`); iPad secileni aynen `archived_flights.lnd_type`a yazar.
// - Sayim INIS sayisiyla: CYCLES 2 + RH CAT I → RH CAT I 2 (Total Landings'in mantigi).
// - Ekip suzgecinde yalniz o pilotun PF oldugu inisler sayilir — inisi PF yapar.
// - Tipi kayitli olmayan ucus (22 Eyl 2026'dan once arsivlenen, kagit OFP)
//   0 olarak SAYILMAZ, ayri "kayitsiz" sayilir (Ilke 1 — Day/Night Not Measured deseni).
// - Listede olmayan bir tip gelirse (iPad listesi buyurse) kendi kutusunu alir,
//   sessizce kaybolmaz.
// - 31 Eki 2026 (Build 77 geri bildirimi, Serkan): *"SA CAT 2 olacak, OTS degil"* — `LH SA CAT II (HUD/EVS)`
//   (SA = Special Authorisation). Eski `LH OTS CAT II (HUD/EVS)` kayitlari eski adiyla kalir (demo donemi: eski
//   veri tasinmaz) ve kendi kutusunda sayilir — yukaridaki "listede olmayan tip" kurali.
export const INIS_TIPLERI = ['LH CAT I', 'RH CAT I', 'LH SA CAT II (HUD/EVS)'];

/**
 * @param {Array} flights  STATISTICS'in suzulmus ucus listesi
 * @param {(f: object) => string} pfOf  ucusun PF'inin kimligi
 * @param {string} pilotId  ekip suzgeci ('' = hepsi)
 * @returns {{ sayim: Record<string, number>, kayitsiz: number }}
 */
export function inisTipiSayim(flights, pfOf, pilotId) {
  const sayim = Object.fromEntries(INIS_TIPLERI.map((t) => [t, 0]));
  let kayitsiz = 0;
  for (const f of flights || []) {
    if (pilotId && pfOf(f) !== pilotId) continue;
    const tip = typeof f.lnd_type === 'string' ? f.lnd_type.trim() : '';
    if (!tip) { kayitsiz += 1; continue; }
    sayim[tip] = (sayim[tip] || 0) + (Number(f.landing_count) || 0);
  }
  return { sayim, kayitsiz };
}

// ── LISTEDE KISA GOSTERIM (22 Eyl 2026, Serkan) ────────────────────────
// 🔑 *"Bunu aynı zamanda landing kolonda göstermelisin: 1/ LH C1 ve 2/ RH C1
//    veya 1/ LH OC2."* Kısaltmalar Serkan'ın; sütun dar, tam metin sığmaz.
// Listede olmayan bir tip gelirse KISALTILMAZ, olduğu gibi yazılır — sessizce
// boş göstermek kaydı gizlemek olurdu (İlke 1).
export const INIS_TIPI_KISA = {
  'LH CAT I': 'LH C1',
  'RH CAT I': 'RH C1',
  'LH SA CAT II (HUD/EVS)': 'LH SA C2', // 31 Eki 2026, Serkan: *"SA C2 olabilir mi"*
  // Eski ad (31 Eki 2026 oncesi kayitlar) — listede eskisi gibi kisa gorunsun.
  'LH OTS CAT II (HUD/EVS)': 'LH OC2',
};

/** `1 / LH C1` gibi: iniş sayısı + kısa tip. Tip yoksa yalnız sayı. */
export function inisHucresi(sayi, tip) {
  const n = Number(sayi) || 0;
  const s = n ? String(n) : '—';
  const t = typeof tip === 'string' ? tip.trim() : '';
  if (!t) return s;
  return `${s} / ${INIS_TIPI_KISA[t] || t}`;
}

